import React from 'react';
import {message, notification} from 'antd';
import {get} from 'lodash';
import $ from 'jquery';
import {ClientsActions} from './actions';
import ProtectedLayout from '../../common/protected-layout';
import {ClipLoader} from 'halogenium';
import {UpdateManyModel} from './modals/update-many-modal';
import {Route} from 'react-router-dom';
import {ImportExcelModal} from './modals/import-excel-modal';
import {normalizePhone} from '../../../utils/normalize-phone';
import {generateSendSmsLink} from '../../../utils/generate-send-sms-link';


// Abstract component
export class BaseClientsList extends React.Component {
  page = '';

  state = {
    sms: false,
    showUpdateMany: false,
  };

  constructor(...args) {
    super(...args);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    this.__loadItems();
  }

  render() {
    console.log('render list', this.page);
    return (
      <ProtectedLayout
        loginStore={this.props.loginStore}
        className="clients-list"
        headerTitle={this.renderTitle()}
        right={this.renderActions()}
        onLogout={::this.onLogout}>
        {this.__isLoadingItems || !this.state.width
          ? <div className={'loading-content'}><ClipLoader color={'#000'} /></div>
          : this.renderContent()}
      </ProtectedLayout>
    );
  }

  renderChild({ columns, items }) {
    return (
      <React.Fragment>
        <UpdateManyModel
          visible={this.state.showUpdateMany}
          columns={columns.filter(i => i.editable && ['number'].indexOf(i.key) === -1)}
          selected={this.getSelectedIds()}
          onClose={() => this.setState({ showUpdateMany: false })}
          onSubmit={::this.onUpdateMany} />

          <Route path={`/${this.page}-clients/import`} component={(props) => <ImportExcelModal {...props} page={this.page} />} />
      </React.Fragment>
    );
  }


  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    setTimeout(() => {
      this.updateDimensions();
    }, 300);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    const w = $('body').innerWidth();
    this.setState({ width: this.state.width ? w : w - 20 });
  }

  onChangeColSize(cols, col, stop, d, t, e, { width } ) {
    //col.cfg.width = width;
    const W = this.state.width - 30;

    const per = px => px / (W / 100);
    const resizeRight = !d.altKey;

    const i = cols.indexOf(col);
    let right = cols[i + 1];
    if(!right) {
      right = cols[i - 1];
    }

    const w = col.cfg.width + width;
    const rightW = right.cfg.width - width;
    if(w < 30 || (rightW < 30 && resizeRight)) {
      return ;
    }

    $(`.t-${col.className}`).css('width', w + 'px');
    if(resizeRight) {
      $(`.t-${right.className}`).css('width', rightW + 'px');
    }

    if(stop) {
      this.updateColSettings(col.key, per(w));
      if(resizeRight) {
        this.updateColSettings(right.key, per(rightW));
      }

      this.saveUpdatedSettings();
      this.setState({ });
    }
  }

  applyColSettings(cols) {
    const settings = this.props.loginStore.settings[this.page];
    let W = this.state.width - 30 - 2;// 30 для чекбоксов, 2 для border
    let leftW = W;
    let dCols = cols.length;

    const px = (per) => per * (W / 100);

    const fields = (settings && settings.fields) || {};
    const getW = col => {
      let per = fields[col.key];
      if(per) {
        if(per > 50) {
          per = 50;
        }
        if(per < 0) {
          per = 3;
        }

        return px(per);
      }
    };


    for(const col of cols) {
      const w = getW(col);
      if(w) {
        leftW-= w;
        dCols--;
      }
    }


    for(const col of cols) {
      let w = getW(col);
      const dSize = leftW / 100 * ((100 / dCols));
      col.cfg = {
        width: w || dSize
      };

      col.className = col.key.split('.').join('_');

      col.format = function(row) {
        if(col.formatter) {
          if(col.formatter.getRaw) {
            return col.formatter.getRaw(get(row, col.key));
          }
          let v = col.formatter({ row });
          if(typeof v === 'function') {
            return v(get(row, col.key));
          } else {
            return v;
          }
        } else {
          return get(row, col.key);
        }
      }
    }
  }

  saveUpdatedSettings() {
    this.props.loginStore.saveSettings();
  }

  updateColSettings(key, value) {
    console.log('new col Setting', key, value);
    this.props.loginStore.extendTableFieldSettings(this.page, key, value);
  }

  getColsSettings() {
    return JSON.parse(this.props.loginStore.settings[this.page + 'TableFields']);
  }


  renderTitle() {
    const checked = this.refs.listview && this.refs.listview.state.checked;
    const selectedIds = this.getSelectedIds();

    if (!selectedIds.length) {
      return '';
    }

    if (this.props.loginStore.user.user.type === 'admin') {
      let totalPrice = 0;
      for (const row of this.clients) {
        if (checked && checked[row.cid]) {
          totalPrice+= row.price ? parseInt(row.price.replace(/\D/g,'')) : 0;
          totalPrice+= row.night_price ? parseInt(row.night_price.replace(/\D/g,'')) : 0;
        }
      }

      return <h2>Выбрано: {selectedIds.length} ТС, Стоимость: {totalPrice}</h2>;
    } else {
      return <h2>Выбрано: {selectedIds.length}</h2>
    }

    return '';
  }

  onChangeChecked() {
    this.forceUpdate();
  }


  renderActions() {
    const { isAdmin } = this.props.loginStore;

    return (
      <ClientsActions
        isAdmin={isAdmin}
        page={this.page}
        hasSelected={true}
        onRemoveSelected={::this.removeSelected}
        onCheckSelected={::this.checkSelected}
        onExport={::this.exportSelected}
        onToggleSms={::this.toggleSms}
        onMoveUp={::this.moveUp}
        onSendSms={::this.sendSms}
        onMoveSelected={::this.moveSelected}/>
    );
  }


  onClickAction(row, { key }) {
    if(key === 'remove') {
      this.removeSelected();
    } else if(key === 'forceCheck') {
      this.checkSelected();
    } else if(key === 'updateMany') {
      this.setState({ showUpdateMany: true });
    } else if(key === 'moveToOur') {
      this.moveSelected('our');
    } else if(key === 'moveToReq') {
      this.moveSelected('req');
    } else if(key === 'moveToArc') {
      this.moveSelected( 'arc');
    } else if(key === 'orderUp') {
      this.moveUp();
    } else if(key === 'sendSms') {
      this.sendSms();
    }
  }

  async onChangeEditableField(row, col, next) {
    console.log('on change editable')
    const current = row[col.key];
    if(next === current) {
      console.log('false');
      return false;
    }

    if(col.key === 'cid') {
      return this.onReorder(current, next);
    }

    try {
      const res = await this.editRow(row, {[col.key]: next });
      if(!res)
        return false;

    } catch(e) {
      console.log('error edit', e);
      return false;
    }

    row[col.key] = next;
    message.success('Внесенные изменения сохранены');
    return true;
  }

  async onReorder(current, next) {
    next = parseInt(next.trim());
    current = parseInt(current);

    const max = this.clients.length + 1;
    if(!next || isNaN(next) || next === Infinity || next < 1 || next > max) {
      message.error(`Введите число от 1 до ${max}`);
      return false;
    }

    if(next === current) {
      return false;
    }
    return await this.__reorder(current, next);
  }

  async onChangeSendSms(row, e) {
    const $checkbox = $(e.nativeEvent.target).parents('.ant-checkbox');

    const revertState = () => {
      row.sendSms = !row.sendSms;
      if(row.sendSms) {
        $checkbox.addClass('ant-checkbox-checked');
      } else {
        $checkbox.removeClass('ant-checkbox-checked');
      }
      // hack for performance issue
    };

    revertState();
    const done = message.loading('Сохранение изменений..', 0);

    const res = await this.editRow(row, { sendSms: row.sendSms });
    done();
    if(!res) {
      revertState();
    }
  }

  async checkSelected() {
    const selectedRows = this.getSelectedRows();
    console.log('selected', selectedRows)
    if(selectedRows.length === 1) {
      return this.checkOne(selectedRows[0]);
    }

    for(let i = 0; i < selectedRows.length; i++) {
      const done = message.loading(`Обновление пропусков ${i + 1}/${selectedRows.length}..`, 0);
      await this.checkOneRow(selectedRows[i]);
      done();
    }
  }

  async checkOne(row) {
    const done = message.loading(`Проверка пропуска ${row.number}`, 0);
    await this.checkOneRow(row);
    done();
  }


  async checkOneRow(row) {
    const ok = await this.checkRow(row);
    if(ok) {
      console.log('notification success');
      notification.success({
        message: 'Пропуск обновлен',
        description: `Пропуск машины ${row.number} обновлен успешно!`
      });
      return true;
    } else {
      notification.error({
        message: 'Ошибка обновления пропуска',
        description: `Ошибка при обновлении пропуска ${row.number}`
      });
      return false;
    }
  }

  moveUp() {
    const selectedRows = this.getSelectedRows();
    if(selectedRows) {
      return this.__orderUp(selectedRows.map(r => r.number));
    }
  }


  moveSelected(to) {
    const selectedRows = this.getSelectedRows();
    if(selectedRows) {
      return this.__move(selectedRows.map(r => r.number), to);
    }
  }

  async removeOne(row) {
    const res = await this.removeRows([row.cid]);
    if(res) {
      message.success('Машина удалена!');
    }
  }

  async removeSelected() {
    const selectedIds = this.getSelectedRows().map(r => r.cid);
    console.log('remove selected ids', selectedIds);

    const res = await this.removeRows(selectedIds);
    if(res) {
      message.success('Выбранные машины удалены!');
    }
  }

  async exportSelected() {
    const selectedRows = this.getSelectedRows();
    if(selectedRows) {
      this.__export(selectedRows.map(r => r.number), this.page);
    }
  }


  async onUpdateMany(data) {
    this.setState({ showUpdateMany: false });
    const ids = this.getSelectedRows().map(i => i.id);

    let res;
    if (data.fieldName === 'cid') {
      const cid = parseInt(data.value);
      if (!cid) {
        alert('Введите число');
      }

      res = await this.__reorderMany(ids, cid);
    } else {
      res = await this.__updateMany(ids, data);
    }

    if (res) {
      message.success('Выбранные машины обновлены');
    }
  }

  getSelectedRows(allowEmpty = false) {
    const selectedIds = this.getSelectedIds();
    if(selectedIds.length < 1) {
      if (allowEmpty) {
        return [];
      } else {
        message.error('Не выбраны машины для выполнения операции');
        return ;
      }
    }
    const clients = this.clients;

    if(selectedIds.length === clients.length) {
      return clients;
    }

    const res = [];
    for(let row of clients) {
      if(selectedIds.indexOf(row.cid) > -1) {
        res.push(row);
      }
    }

    return res;
  }

  getSelectedIds() {
    const checked = this.refs.listview && this.refs.listview.state.checked;
    return checked ? Object.keys(checked).filter(i => checked[i]).map(i => parseInt(i)) : [];
  }

  onLogout() {
    this.props.loginStore.logout();
  }

  toggleSms() {
    this.__setSendSms(this.getSelectedRows().map(i => i.number), !this.state.sms);
    this.setState({sms: !this.state.sms});
  }

  sendSms() {
    const selected = this.getSelectedRows(true);
    const phonesMap = {};
    for (const one of selected) {
      const phone = normalizePhone(one.phone);
      if (phone) {
        phonesMap[phone] = true;
      }
    }

    this.props.history.push(generateSendSmsLink(Object.keys(phonesMap)));
  }


  // API
  async __reorder(current, next) {
    return await this.__store.reorder(this.page, current, next);
  }

  async __orderUp(numbers) {
    return this.__store.orderUp(this.page, numbers);
  }


  async __move(numbers, to) {
    this.__store.move(numbers, this.page, to);
  }

  async __updateMany(itemIds, data) {
    return this.__store.updateMany(this.page, itemIds, data);
  }

  async __reorderMany(ids, to) {
    return this.__store.reorderMany(this.page, ids, to);
  }


  async __export(numbers) {
    this.__store.export(numbers, this.page);
  }

  async __setSendSms(numbers, state) {
    this.__store.setSendSms(this.page, numbers, state);
  }

  __loadItems() {
    this.__store.loadAll();
  }

  get __isLoadingItems() {
    return this.__store.isLoadingClients;
  }

  get __store() {
    return this.props.clientsStore;
  }


  async editRow(row, data) {
    throw new Error('should be implemented editRow on base-list');
  }

  async checkRow(row) {
    throw new Error('should be implemented checkRow on base-list');
  }

  async removeRows(ids) {
    throw new Error('should be implemented removeRows on base-list');
  }

  async moveRows(numbers) {
    throw new Error('should be implemented moveRows on base-list');
  }

  get clients() {
    throw new Error('should be implemented in child');
  }

  get settings() {
    return this.props.loginStore.settings[this.page + 'TableFields'];
  }


}



// WEBPACK FOOTER //
// ./src/components/pages/clients/base-list.js